/**
 * W1-11a (app-registry-keymap): FeatureModule discovery (ARCHITECTURE.md §6.1).
 *
 * Collects the default export (FeatureModule) of every `src/features/**\/*.module.{ts,tsx}` with import.meta.glob
 * (no shared index file: a package plugs in by adding its own module file) plus the shell's own module, in a
 * stable order: shell first, then by path. Duplicate ids are detected by the registry (registryCore.ts).
 */

import shellModule from '../shell/shell.module';
import type { FeatureModule } from './types';

const featureModules = import.meta.glob<{ readonly default: FeatureModule }>('/src/features/**/*.module.{ts,tsx}', {
  eager: true,
});

/** Every module's path and default export, shell first then sorted by path. */
export function loadModuleEntries(): ReadonlyArray<{ readonly path: string; readonly module: FeatureModule }> {
  const sorted = Object.entries(featureModules).sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
  return [
    { path: '/src/app/shell/shell.module.tsx', module: shellModule },
    ...sorted.map(([path, mod]) => ({ path, module: mod.default })),
  ];
}

export function loadModules(): readonly FeatureModule[] {
  return loadModuleEntries().map((e) => e.module);
}
